export default "__VITE_ASSET__feae98a1__"